import React from 'react';
import { TestimonialCard } from './TestimonialCard';
import { ShieldCheckIcon } from 'lucide-react';
import { useCountdown } from '../hooks/useCountdown';
export function WhatYouGetSection() {
  const {
    isExpired
  } = useCountdown();
  return <div className="grain-section w-full px-6 py-32 md:py-40 bg-white" data-id="element-368">
      <div className="max-w-6xl mx-auto space-y-32" data-id="element-369">
        {/* Chapter 4 */}
        <div className="space-y-16" data-id="element-370">
          <div className="flex flex-col md:flex-row md:items-center gap-8 mb-8" data-id="element-371">
            <div className="text-8xl md:text-9xl font-black text-teal-50 font-sans tracking-tighter" data-id="element-372">
              04
            </div>
            <div className="h-px w-24 bg-teal-100 hidden md:block" data-id="element-373"></div>
            <div data-id="element-374">
              <p className="text-xs text-teal-600 font-bold tracking-widest uppercase mb-3" data-id="element-375">
                Chapter Four
              </p>
              <h2 className="text-4xl md:text-6xl font-bold text-ink tracking-tight" data-id="element-376">
                Why This Offer Exists <br data-id="element-377" />
                <span className="text-teal-600" data-id="element-378">(And Why It Won't Last)</span>
              </h2>
            </div>
          </div>

          <div className="space-y-8 text-xl text-ink-light leading-relaxed font-light" data-id="element-379">
            <p data-id="element-380">
              Normally, this level of attention is reserved for our private
              transformation clients. The people investing $15,000 – $120,000 to
              have their entire biology rebuilt from the inside out.
            </p>
            <p data-id="element-381">
              But we wanted to create a way for a small number of people... To
              experience that same level of precision thinking... Without
              needing to commit to a full transformation program upfront.
            </p>

            <div className="bg-page-bg p-12 rounded-[3rem] border border-black/5 my-10 space-y-6 shadow-inner" data-id="element-382">
              <p className="text-2xl font-bold text-ink" data-id="element-383">
                So we created Meeting With the Master: ADVANCED.
              </p>
              <p data-id="element-384">
                It's designed to give you the clarity and roadmap you've been
                searching for... In a single intensive session.
              </p>
              {isExpired ? <p className="text-3xl font-bold text-teal-600" data-id="element-385">
                  Available now for $5,000.
                </p> : <p className="text-3xl font-bold text-teal-600" data-id="element-386">
                  Normally priced at $5,000. But for 3 days only... You can get
                  the full Advanced experience for just $1,500.
                </p>}
              <p className="text-sm font-bold uppercase tracking-widest text-ink/40" data-id="element-387">
                The same price as our basic consult.
              </p>
            </div>
          </div>
        </div>

        {/* Chapter 5 */}
        <div className="space-y-16 pt-32 border-t border-black/5" data-id="element-388">
          <div className="grid md:grid-cols-2 gap-8" data-id="element-389"></div>

          <div className="space-y-8" data-id="element-390">
            <TestimonialCard text="I am a physician with an integrative medicine practice and your work has been very valuable in treating my patients. When I lecture to physicians I always mention 'peptide mastery' as a great source of material and extensive references... It has been very helpful in my care of patients and I appreciate the extensive references." name="Ronald R., Peptide Mastery Owner" data-id="element-391" />
            <TestimonialCard text="I'm going through the peptide mastery and all the other peptide courses and resources I've purchased from you guys (I am LOVING it all!!)... I'm a functional medicine practitioner and I can't wait to incorporate some of these protocols with my patients!!!" name="Michelle M.N., Doctor of Chiropractic & Certified Functional Medicine Practitioner" data-id="element-392" />
          </div>
        </div>
      </div>
    </div>;
}